import React from 'react';
import './styles.scss';
import { ReactComponent as BurgerIcon } from '../../../assets/icons/burger-icon.svg';
import { ReactComponent as StarIcon } from '../../../assets/icons/star-filled.svg';
import { ReactComponent as DotIcon } from '../../../assets/icons/dot.svg';
type DataType = {
  comment: string;
  created_at: string;
  logo: string;
  name: string;
  order_code: string;
  rate: string;
  user_name: string;
};
const BrandReviewCard = ({ data }: { data: DataType }) => {
  return (
    <div className='border-[0.8px] border-[#EAEBEB] w-[428px] rounded mt-4 px-[18px] pt-[22px] pb-[20px]'>
      <div className='flex items-center gap-4 text-[18px] font-medium'>
        <BurgerIcon />
        <p>{data.order_code}</p>
        <DotIcon />
        <div className='flex gap-1 items-center bg-[#F2F2F2] rounded-full px-[8px] leading-[150%]'>
          <p className='object-contain text-[#5E6164] font-medium'>{data.rate}</p>
          <StarIcon />
        </div>
      </div>
      <p className=' pt-[10px] eucledian  text-[15px] font-medium text-[#2e3031] leading-[170%]'>
        {data.comment ? data.comment : 'No comment'}
      </p>
      <hr className='my-[12px] text-[#F2F2F2]' />
      <div className='flex justify-between items-center text-sm'>
        <div className='flex gap-2 items-center text-[#6F7376]'>
          <p className=''>Today</p> <DotIcon /> <p> 08:12</p>
        </div>

        <p className='text-[#5E6164]'>{data.user_name}</p>
      </div>
    </div>
  );
};

export default BrandReviewCard;
